import Modal from '../shared/Modal';
import { Stack } from '../shared/layouts';
import Box from '../shared/layouts/Box';
import RadioButton from '../shared/RadioButton';
import Flex from '../shared/layouts/Flex';
import Button from '../shared/Button';
import IconLink from './IconLink';
import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import UserContext from '../../context/UserContext';
import WhiteLabelContext from '../../context/WhiteLabelContext';
import useIconLibrary from '../../hooks/useIconLibrary';
import axios from 'axios';

const UserUtilities = ({ closeSubMenus }) => {
  const { t, i18n } = useTranslation();
  const { LogoutIcon, SettingsIcon, LanguageIcon } = useIconLibrary();
  const { multipleDossiers } = useContext(WhiteLabelContext);

  const { logoutUser, linkedDossiers, dossierName, user } = useContext(UserContext);
  const [switchDossierIsOpen, setSwitchDossierIsOpen] = useState(false);
  const [sessionDossier, setSessionDossier] = useState(user?.dossier);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const canSwitchDossiers = multipleDossiers && linkedDossiers?.length > 1;

  const handleSubmit = () => {
    setLoading(true);

    axios
      .post('/set-session', { dossier: sessionDossier })
      .then(() => window.location.reload())
      .catch(err => {
        setLoading(false);
        if (err.response.status !== 422) {
          setErrors({
            dossier: [t('Geselecteerde dossier is niet beschikbaar')]
          });
        } else {
          setErrors(err.response.data.errors);
        }
      });
  };

  return (
    <>
      <Box borderTop={'default'} px={'l'} py={'m'}>
        {canSwitchDossiers && (
          <Flex
            flexDirection={'column'}
            justifyContent={'center'}
            onClick={() => setSwitchDossierIsOpen(true)}
            mb={{ mobile: 'l', desktop: 'm' }}
            css={{ cursor: 'pointer' }}
          >
            <Box fontWeight={'bold'} lineHeight={'1rem'}>
              {dossierName}
            </Box>
            <Box fontScale={'xs'} mt={'2px'} css={{ textDecoration: 'underline' }}>
              {t('Wissel van dossier')}
            </Box>
          </Flex>
        )}
        <Flex justifyContent={'space-between'}>
          <IconLink
            to={'user/settings'}
            title={t('Instellingen')}
            onClick={closeSubMenus}
            Icon={SettingsIcon}
          />
          <IconLink
            to={'user/settings/edit-language'}
            title={t('Taal instelling')}
            onClick={closeSubMenus}
            Icon={LanguageIcon}
          >
            <Box ml={'xs'}>
              {i18n.language?.toUpperCase()}
            </Box>
          </IconLink>
          <IconLink
            to={'/login'}
            title={t('Uitloggen')}
            onClick={logoutUser}
            Icon={LogoutIcon}
            hoverColor={'alert'}
          />
        </Flex>
      </Box>
      <Modal
        isOpen={switchDossierIsOpen}
        onRequestClose={() => setSwitchDossierIsOpen(false)}
      >
        <Stack space={'m'}>
          <Box fontScale="xl" fontWeight="bold">
            {t('Wissel van dossier')}
          </Box>
          <Box>{t('Welk dossier wil je gebruiken?')}</Box>
          <RadioButton
            name={'dossier'}
            value={sessionDossier}
            onChange={value => setSessionDossier(value)}
            options={linkedDossiers}
            errors={errors?.dossier}
          />
          <Flex
            flexDirection={{ mobile: 'column-reverse', desktop: 'row' }}
            justifyContent={{ mobile: 'flex-start', desktop: 'flex-end' }}
            css={({ space }) => ({ gap: space.m })}
          >
            <Button
              variant="primary-outline"
              width={{ mobile: '100%', desktop: 'auto' }}
              onClick={() => setSwitchDossierIsOpen(false)}
              disabled={loading}
            >
              {t('Annuleren')}
            </Button>
            <Button
              variant="primary"
              width={{ mobile: '100%', desktop: 'auto' }}
              onClick={handleSubmit}
              disabled={loading}
            >
              {t('Bevestigen')}
            </Button>
          </Flex>
        </Stack>
      </Modal>
    </>
  );
};

export default UserUtilities;
